/**
 * Módulo separado para usar import.meta.glob (Vite).
 * Em Jest este módulo é mockado em tests/__mocks__/logoCredorAssets.ts
 *
 * `logoModules`: credor principal (securitizadora) em `logo-credores`. A fase 2 do destaque do
 * credor originário não carrega imagem de logo de terceiro, então `logo-subcredores` não é lido.
 */
export const logoModules = import.meta.glob<{ default: string }>(
  '@/assets/images/logo-credores/*.png',
  { eager: true },
);
